export default function loadYoutube() {
	let youtube = document.querySelectorAll( ".video-youtube" );
	if ( youtube ) {
		Array.from( youtube ).forEach(
			( video, index ) => {
            const source = "https://img.youtube.com/vi/" + youtube[index].dataset.embed + "/sddefault.jpg";
            const image  = new Image();
            image.src    = source;
            image.addEventListener(
				"load",
				function() {
					youtube[ index ].appendChild( image );
				}( index )
			);
			youtube[index].addEventListener(
				"click",
				function() {

					const iframe = document.createElement( "iframe" );

					iframe.setAttribute( "frameborder", "0" );
					iframe.setAttribute( "allowfullscreen", "allowFullScreen" );
					iframe.setAttribute( "allow", "autoplay" );
					iframe.setAttribute( "src", "https://www.youtube.com/embed/" + this.dataset.embed + "?rel=0&showinfo=0&autoplay=1" );

					this.innerHTML = "";
					this.appendChild( iframe );
				}
			);
			}
		);
	}
}

document.addEventListener(
	'DOMContentLoaded',
	() => {
		loadYoutube();
	}
)
